export const COLLABORATOR_TYPES = {
  pos: {
    value: 'pos',
    label: 'PDV',
    description: 'Acessa somente o PDV dos pontos de venda vinculados.',
    permissions: ['pos']
  },
  kitchen: {
    value: 'kitchen',
    label: 'Cozinha',
    description: 'Acessa somente a tela de pedidos dos pontos de venda vinculados.',
    permissions: ['orders']
  },
  partner: {
    value: 'partner',
    label: 'Parceiro',
    description: 'Cria reservas, envia vouchers e acompanha as próprias reservas.',
    permissions: ['scheduler', 'reservations', 'vouchers']
  },
  validator: {
    value: 'validator',
    label: 'Validador',
    description: 'Lê o QR Code do voucher e confirma o check-in do cliente.',
    permissions: ['voucher_validation']
  }
};

export const DEFAULT_COLLABORATOR_TYPE = 'partner';
export const DEFAULT_COLLABORATOR_TYPES = [DEFAULT_COLLABORATOR_TYPE];

export const getPermissionsForCollaboratorType = (type) => {
  return COLLABORATOR_TYPES[type]?.permissions || COLLABORATOR_TYPES[DEFAULT_COLLABORATOR_TYPE].permissions;
};

export const normalizeCollaboratorTypes = (value) => {
  if (Array.isArray(value) && value.length > 0) {
    return [...new Set(value.filter(type => COLLABORATOR_TYPES[type]))];
  }

  if (typeof value === 'string' && COLLABORATOR_TYPES[value]) {
    return [value];
  }

  return DEFAULT_COLLABORATOR_TYPES;
};

export const getPermissionsForCollaboratorTypes = (types) => {
  return [...new Set(
    normalizeCollaboratorTypes(types).flatMap(type => getPermissionsForCollaboratorType(type))
  )];
};

export const getCollaboratorTypeLabel = (type) => {
  return COLLABORATOR_TYPES[type]?.label || COLLABORATOR_TYPES[DEFAULT_COLLABORATOR_TYPE].label;
};

export const getCollaboratorTypesLabel = (types) => {
  return normalizeCollaboratorTypes(types).map(getCollaboratorTypeLabel).join(', ');
};

export const getUserPermissions = (userData) => {
  if (!userData) return [];

  const explicitPermissions = [
    ...(Array.isArray(userData.permissions) ? userData.permissions : []),
    ...(Array.isArray(userData.companyPermissions) ? userData.companyPermissions : [])
  ];

  if (explicitPermissions.length > 0) {
    return [...new Set(explicitPermissions)];
  }

  const companies = Array.isArray(userData.companies) ? userData.companies : [];
  const currentCompany = companies.find(company =>
    company.companyId === userData.currentCompanyId ||
    company.id === userData.currentCompanyId ||
    company.companyId === userData.companyId ||
    company.id === userData.companyId
  );

  const companyPermissions = [
    ...(Array.isArray(currentCompany?.permissions) ? currentCompany.permissions : []),
    ...(Array.isArray(currentCompany?.companyPermissions) ? currentCompany.companyPermissions : [])
  ];

  if (companyPermissions.length > 0) {
    return [...new Set(companyPermissions)];
  }

  const collaboratorTypes = currentCompany?.collaboratorTypes ||
    currentCompany?.collaboratorType ||
    userData.collaboratorTypes ||
    userData.collaboratorType;

  return getPermissionsForCollaboratorTypes(collaboratorTypes);
};

export const hasPermission = (userData, permission) => {
  if (!permission) return true;
  if (['root', 'admin', 'operational'].includes(userData?.role)) return true;
  if (userData?.role !== 'collaborator') return false;
  return getUserPermissions(userData).includes(permission);
};

export const getAuthenticatedHomePath = (userData) => {
  if (userData?.role !== 'collaborator') return '/';
  if (hasPermission(userData, 'scheduler')) return '/agendamento';
  if (hasPermission(userData, 'voucher_validation')) return '/validar-voucher';
  if (hasPermission(userData, 'pos')) return '/pos';
  if (hasPermission(userData, 'orders')) return '/orders';
  return '/agendamento';
};

export const canAccessMenuItem = (userData, item) => {
  if (!item) return false;
  if (item.roles && !item.roles.includes(userData?.role)) return false;
  if (!item.permission) return true;
  return hasPermission(userData, item.permission);
};
